
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-06-15-r3f-mixing-html",
      function () {
        return require("private-next-pages/blogs/2025-06-15-r3f-mixing-html/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-06-15-r3f-mixing-html"])
      });
    }
  